import React from 'react';
import CAMembershipInputComponent from '../components/reports/input/CAMembershipInputComponent';

const CAMembershipVerification = () => {
    // Service details for CA Membership
    const serviceDetails = {
        id: 9,
        name: 'CA Membership Verification',
        provider: 'Tartan'
    };

    return (
        <div className="grid">
            <div className="col-12">
                <CAMembershipInputComponent 
                    serviceId={9} 
                    serviceDetails={serviceDetails} 
                />
            </div>
        </div>
    );
};

export default CAMembershipVerification;